// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'expose-loader?$!expose-loader?jQuery!jquery'
import VueGeolocation from 'vue-browser-geolocation';

import naver from 'vue-naver-maps';
Vue.use(naver, {
  clientID: 'no918p1hfa',
  useGovAPI: false, //공공 클라우드 API 사용 (선택)
  subModules:'' // 서브모듈 (선택)
});

Vue.config.productionTip = false;
Vue.use(VueGeolocation);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js